import { Card, Fade, Grid, makeStyles, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotification,
  saveNotification,
} from "../../redux/notification/actions";
import successMessageIcon from "../../assets/images/icons/successMessage.png";
import errorMessageIcon from "../../assets/images/icons/errorMessage.png";

const useStyles = makeStyles((theme) => ({
  message: {
    width: "40%",
    height: "30%",
    position: "absolute",
    top: "20%",
    left: 0,
    right: 0,
    margin: "auto",
    zIndex: 10000,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  messageIcon: {
    marginBottom: theme.spacing(2),
  },
  notification: {
    position: "absolute",
    top: 30,
    padding: `${theme.spacing(2)}px ${theme.spacing(5)}px`,
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "20%",
    zIndex: 10000,
  },
}));

const commingtNotifications = [];

export const Notification = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { message, notification, error } = useSelector(
    (state) => state.notification
  );
  const [currentNotification, setCurrentNotification] = useState(null);

  useEffect(() => {
    dispatch(clearNotification());
  }, [dispatch]);

  useEffect(() => {
    const id = setInterval(() => {
      if (commingtNotifications.length > 0) {
        setCurrentNotification(commingtNotifications.shift());
      }
    }, 2000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (notification != null) {
      commingtNotifications.push(notification);
    }
  }, [notification]);

  useEffect(() => {
    if (!message) {
      return;
    }
    setTimeout(() => {
      dispatch(saveNotification({ message: "", error: false }));
    }, 2000);
  }, [message, dispatch]);

  return (
    <>
      <Fade in={!!currentNotification}>
        <Card className={classes.notification}>
          <Typography align="center">{currentNotification}</Typography>
        </Card>
      </Fade>

      <Fade in={!!message}>
        <Card className={classes.message}>
          <Grid
            container
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ height: "100%" }}
          >
            {message && (
              <img
                className={classes.messageIcon}
                src={error ? errorMessageIcon : successMessageIcon}
                alt="message-icon"
              />
            )}
            <Typography align="center">{message}</Typography>
          </Grid>
        </Card>
      </Fade>
    </>
  );
};
